<template>
    <div class="related-menu-wrapper">
        <button class="icon-btn" type="button" aria-label="Episodes" :aria-expanded="visible" @click="$emit('toggle')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M13.8476 13.317L9.50515 18.2798C8.70833 19.1905 7.29167 19.1905 6.49485 18.2798L2.15238 13.317C1.49259 12.563 1.49259 11.437 2.15238 10.683L6.49485 5.72018C7.29167 4.80952 8.70833 4.80952 9.50515 5.72017L13.8476 10.683C14.5074 11.437 14.5074 12.563 13.8476 13.317Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M13 19L17.8844 13.3016C18.5263 12.5526 18.5263 11.4474 17.8844 10.6984L13 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M17 19L21.8844 13.3016C22.5263 12.5526 22.5263 11.4474 21.8844 10.6984L17 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
        </button>

        <transition name="stream-menu">
            <div class="related-menu" v-if="visible" @click.stop>
                <div class="content-row" v-if="mode === 'sport'">
                    <div v-for="(c,i) in related" :key="i">
                        <Sport :sport="c"  class="sport" v-ripple mode="notlive"/>
                    </div>
                </div>

                <div class="content-row" v-if="mode === 'live' || mode === 'epg'">
                    <div v-for="(c,i) in related" :key="i" >
                      <Channel v-ripple :channel="c"/>
                    </div>
                </div>

                <div class="content-row" v-if="mode === 'od' ">
                    <div  v-for="(content, i) in related" :key="i" @click.prevent="goToMovie(content)" >
                        <Movie :media="content" :list="true" :display="true" />
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
const Sport= () =>  import('/src/components/Sport.vue')
const Channel  = () => import('@/components/Channel')
const Movie = () => import('@/components/Movie.vue')

export default {
    name: 'RelatedMenu',
    components: {
        Movie,
        Sport,
        Channel
    },
    props: {
        visible: { type: Boolean, default: false },
        mode: String,
        related: Array
    },
    methods: {
         goToMovie(s){
            const path = `/theater?mode=od&type=movie&id=${s.id}`
            this.$router.push(path).catch(() => {})
        },

    },
}
</script>

<style lang="scss" scoped>
.related-menu-wrapper {
    position: relative;
    display: inline-flex;
}

.related-menu {
    position: absolute;
    bottom: calc(100% + 32px);
    right: -8px;
    z-index: 20;
    width: 510px;
    background: rgba(24, 24, 26, 0.94);
    backdrop-filter: blur(18px) saturate(1.4);
    -webkit-backdrop-filter: blur(18px) saturate(1.4);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.06);
    overflow: hidden;
    transform-origin: center;
    max-height: 600px;
    overflow-y: scroll;
}
.content-row{
    width: calc(100% - 40px);
    margin: 0;
    padding: 20px;
    justify-content: space-between;
    flex-direction:row;
    flex-wrap: wrap;
    gap: 10px;

}
</style>
<style lang="scss" >
.related-menu a > div{
    padding: 0!important;
    margin: 0!important;
    &:hover{
        opacity: 0.8;
    }
}
</style>
